export class SGService {
  constructor(app, axios, cmsUrl, apiUrl, store, route, router) {
    this.$app = app;
    this.$axios = axios;
    this.cmsUrl = cmsUrl;
    this.apiUrl = apiUrl;
    this.store = store;
    this.route = route;
    this.router = router;
  }

  async getOctoberData(path) {
    return await this.$axios.get(this.cmsUrl + path)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error('Error getting cms path ' + path);
        console.error(error);
        return undefined;
      });
  }

  async getApiData(path, headerSessionId) {
    if (headerSessionId) {
      return await this.$axios.get(this.apiUrl + path, 
        {
            headers: {
                'X-SessionId': headerSessionId
            }
        })
        .then(function(response) {
          return response.data;
        })
        .catch(function(error) {
          console.error(error);
          return undefined;
        });
    } else {
      return await this.$axios.get(this.apiUrl + path)
        .then(function(response) {
          return response.data;
        })
        .catch(function(error) {
          console.error(error);
          return undefined;
        });
    }
  }

  async postApiData(path, data) {
    return await this.$axios.post(
        this.apiUrl + path, 
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
        return undefined;
      });
  }

  createUserFranchiseDataObject(franchiseKey, franchiseId, branchCode) {
    return {
      franchise: franchiseKey,
      franchiseId: franchiseId,
      branchCode: branchCode,
      updated: false
    }
  }
  
  saveUserFranchiseDataCookie(cookiz, obj) {
    obj.updated = new Date();
    cookiz.set('user_franchise_data', obj);
  }

  deleteUserFranchiseDataCookie(cookiz) {
    cookiz.set('user_franchise_data', undefined);
  }
  
  getUserFranchiseDataCookie(cookiz, franchiseKey) {
    var cookieData = cookiz.get('user_franchise_data');
    if (cookieData) {
      if (franchiseKey && cookieData.franchise != franchiseKey) {
        return this.createUserFranchiseDataObject(franchiseKey, false, false);
      } else {
        return cookieData;
      }
    } else if (franchiseKey) {
      return this.createUserFranchiseDataObject(franchiseKey, false, false);
    }
  }

  savePersistedStateToCookie(cookiz, state) {
    var copiedState = JSON.parse(JSON.stringify(state));
    copiedState.branchInfo = null;
    copiedState.order = null;
    cookiz.set('user_state', copiedState);
  }

  getPersistedStateFromCookie(cookiz) {
    var stateString = cookiz.get('user_state');
    return stateString;
  }

  isUSZipCode(zip) {
    let regexp = /^[0-9]{5}(?:-?[0-9]{4})?$/;

    if (regexp.test(zip.trim())) {
      return true;
    } else {
      return false;
    }
  }

  async addressLookup(address, $app, performRedirect = true, redirectPath = "", ndcInfo = '', ndcCode = '', tracking = false, manageShowLoader = true) {

    const persistedData = {
      userAddress: address,
      ndcInfo: ndcInfo,
    };
    var ndcCode = ndcCode ? ndcCode : null;

    if(manageShowLoader) { this.store.commit('SET_SHOW_LOADER', true); }

    // Store the data we do have currently
    this.store.commit("SET_STATE", persistedData);

    let branchData = null;
    let franchiseData = undefined;
    var zipCode = undefined;

    // If enter only zipcode then skip 
    if(this.isUSZipCode(address)) {
      zipCode =  address.trim().substring(0, 5);
      this.store.commit("SET_ZIP", zipCode);
    } else {

      var addressRequest = this.getAddressSearchObject(address);
      if(ndcInfo)
      {
        addressRequest.custNo = ndcInfo.custNo
        addressRequest.sqldbid = ndcInfo.sqldbid
      }
      zipCode = addressRequest.zip;
      const useZip = zipCode ? true : false;
      let addressInfo = await this.postApiData(`Addresses/SG/Search?track=${tracking}&useFranchizeZipAssignments=${useZip}`, addressRequest);

      // If we got a valid result
      if (addressInfo !== null && addressInfo !== undefined && addressInfo.length > 0) {

        addressInfo = addressInfo[0];

        this.store.commit('SET_USER_ADDRESS', address);
        this.store.commit('SET_ADDRESS_INFO', addressInfo);
        this.store.commit('SET_ADDRESSLOOKUP', addressInfo.addressLookupId);

        // Populate zip code and session based on getting results
        this.store.commit("SET_ZIP", zipCode);
        const scope = await this.createScope($app, addressInfo.sqldbid, addressInfo.cust_No, ndcCode);
        this.store.commit('SET_SQLDBID', addressInfo.sqldbid);

        // Look up the ndc code if we don't already have one
        if (!ndcCode) {
          const ndcInfo = await this.getApiData(`Offers/Customer/${addressInfo.cust_No}/Offer/Latest?onlyReturnServiceOffers=true`, scope.id);
          if (ndcInfo && !ndcInfo.isExpired) {
            await this.updateScope($app, scope.id, scope.sqldbid, scope.cust_No, scope.orderId, ndcInfo.ndc);
            this.store.commit('SET_NDC_INFO', ndcInfo);
          }
        }

        // Check franchise info here by sqldbid
        franchiseData = await this.getOctoberData("franchise/"+addressInfo.sqldbid+"/sqldbid")

        // If we got franchise data, set branch data
        if (franchiseData) {
          if (franchiseData.length > 1) {
            const filteredFranchise = franchiseData.filter(franchise => franchise.parent_id === 0);
            franchiseData = filteredFranchise.length > 0 ? filteredFranchise[0] : franchiseData[0];
          } else {
            franchiseData = franchiseData[0];
          }

          if (franchiseData?.spring_green_id) {
            this.store.commit('SET_BRANCHCODE', franchiseData.spring_green_id);
            let branchResponse = await this.getOctoberData("branch/" + franchiseData.spring_green_id + "/branchinfo");
            // Branch info request might be an object on success, or an empty array on failure.
            if (branchResponse && !Array.isArray(branchResponse)) {
              branchData = branchResponse;
            }
          }
        }
      }
    }

    // Look up by zip if we didn't pull the branch from the the address
    if (!branchData && zipCode) {
      let branchResponse = await this.getOctoberData("branch/" + zipCode + "/zipcode");
      // Branch info request might be an object on success, or an empty array on failure.
      if (branchResponse && !Array.isArray(branchResponse)) {
        branchData = branchResponse;
      }
      if (branchData) {
        this.store.commit("SET_ZIP", zipCode);
        this.store.commit("SET_BRANCHCODE", branchData.BranchCode);
        franchiseData = await this.getOctoberData("franchise/" + branchData.BranchCode);
        if (franchiseData) {
          franchiseData = franchiseData[0];
        }
      }
    }

    if (!branchData || !franchiseData) {
      if(manageShowLoader) { this.store.commit('SET_SHOW_LOADER', false); }
      this.deleteUserFranchiseDataCookie($app.$cookiz);
      if (performRedirect) { this.router.push("/out-of-area"); }
      return {
        franchise: undefined,
        branch: undefined
      }
    }

    $app.branchLocation = franchiseData.city_state_override;
    this.store.commit("SET_BRANCH_LOCATION", franchiseData.city_state_override);

    const branchPhone = branchData.BranchInfo.InfoData.find(function(data, index) {
      if (data.FieldName === "Business Main Phone") {
        return true;
      }
    });

    $app.branchPhone = branchPhone.FieldValue;
    this.store.commit("SET_BRANCH_PHONE", branchPhone);
    
    const branchMarchExPhone = branchData.BranchInfo.InfoData.find(function(data, index) {
      if (data.FieldName === "MarchEX Digital Phone") {
        return true;
      }
    });

    $app.branchMarchExPhone = branchMarchExPhone.FieldValue;
    this.store.commit("SET_BRANCH_MARCHEXPHONE", branchMarchExPhone);

    // Set cookie to let it know not to override
    $app.$cookiz.set("custom_address", true);

    // Check if scope is set if so, grab the orderInfo
    var scope = this.store.state.persistedState.scope;

    if (scope) {
      if (scope.orderId !== null) {
        const orderInfo = await $app.$orders.getOrderById(
          scope.orderId,
          scope.id
        );

        if (orderInfo.orderStatus !== 'SUBMITTED' && !orderInfo.error) {

          this.store.commit("SET_ORDER_INFORMATION", orderInfo);
        }
      }
    }

    this.store.commit('SET_BRANCH_INFO', branchData);

    if(manageShowLoader) { this.store.commit('SET_SHOW_LOADER', false); }

    // Save cookies about the branch to allow parallel queries later
    var cookieData = this.getUserFranchiseDataCookie(
      $app.$cookiz,
      franchiseData.slug
    );
    cookieData.franchiseId = branchData.SQLDBID;
    cookieData.branchCode = franchiseData.spring_green_id;
    this.saveUserFranchiseDataCookie($app.$cookiz, cookieData);

    if (franchiseData != undefined && franchiseData.slug) {
      this.store.commit('SET_FRANCHISE_SLUG', franchiseData.slug);
      if (performRedirect && !redirectPath) {
        redirectPath = "/lawn-care-locations/" + franchiseData.slug + "/";
      }
    } else if(performRedirect) {
      redirectPath = "out-of-area";
    }

    if (performRedirect) {
      if (this.route?.path == redirectPath) {
        window.location.reload(); // Perform hard refresh to prevent some lingering stale state issues.
      } else {
        window.location.href = redirectPath; // Perform hard refresh to prevent some lingering stale state issues.
      }
    } else {
      return {
        franchise: franchiseData,
        branch: branchData
      }
    }
  }

  getAddressSearchObject(address) {

    // Pull data from submitted address
    const addressSplit = address.split(",");

    // Get the basic portions
    var streetAddress = addressSplit[0].trim();
    var city = addressSplit[1].trim()
    var finalSplit = addressSplit[addressSplit.length-1].trim().split(' ');
    var zipCode = finalSplit[finalSplit.length-1].trim().substring(0, 5);

    // State can be tricky based on if a comma is between state and zip or not
    var state = undefined;
    if (addressSplit.length == 3) {
      var parts = addressSplit[2].trim().split(' ');
      state = parts[0];
    } else if (addressSplit.length == 4) {
      state = addressSplit[2].trim();
    }

    // transform this into address object
    return {
      address: streetAddress,
      city: city,
      state: state,
      zip: zipCode
    };
  }

  async createScope($app, sqldbid, customerNo, ndc) {
    if (!sqldbid) {
      return;
    }

    // create scope here and set it to store
    const scopeInfo = await $app.$scope.createScope({
      sqldbid: sqldbid,
      custNo: customerNo,
      ndc: ndc
    });
    this.store.commit("SET_SCOPE", scopeInfo);
    this.store.commit('SET_SQLDBID', sqldbid);
    if (customerNo) {
      this.store.commit('SET_CUSTOMER_NUMBER', customerNo);
    }
    return scopeInfo;
  }

  async updateScope($app, scopeId, sqldbid, customerNo, orderId, ndc) {
    if (!sqldbid) {
      return;
    }
    // create scope here and set it to store
    const scopeInfo = await $app.$scope.updateScope(scopeId, {
      sqldbid: sqldbid,
      custNo: customerNo,
      ndc: ndc,
      orderId: orderId
    });
    this.store.commit("SET_SCOPE", scopeInfo);
    this.store.commit('SET_SQLDBID', sqldbid);
    if (customerNo) {
      this.store.commit('SET_CUSTOMER_NUMBER', customerNo);
    }
    return scopeInfo;
  }

  async getFranchiseDataAsync(slug) {
    return await this.$axios.get(this.cmsUrl + 'franchises/' + slug)
      .then(function(response) {
        return response.data[0];
      })
      .catch(function(error) {
        return {error: error, response: error.response.data };
      });
  }

  async getBranchInfoAsync(slug) {
    return await this.$axios.get(this.cmsUrl + 'branch/' + branchCode + '/branchinfo')
        .then(function(response) {
          return JSON.parse(response.data.franchise);
        })
        .catch(function(error) {
          return {error: error, response: error.response.data };
        });
  }

  async getAllFranchiseDataAsync(slug, branchCode, franchiseId, getTestimonials) {
    var franchiseData = undefined;
    var ucmsFranchiseData = undefined;
    var branchData = undefined;
    var testimonials = undefined;
    var branchInfo = undefined;
    var branchCode = undefined;
    var redirectSlug = undefined;

    if (slug && branchCode && franchiseId) {
      var promises = [];

      promises.push(this.$axios.get(this.cmsUrl + 'franchises/' + slug)
        .then(function(response) {
          franchiseData = response.data[0];
          redirectSlug = franchiseData.redirect_url;
        })
        .catch(function(error) { })
      );

      promises.push(this.$axios.get(this.cmsUrl + 'branch/' + branchCode + '/branchinfo')
        .then(function(response) {
          branchData = response.data;
          branchInfo = branchData;
        })
        .catch(function(error) { })
      );
      
      promises.push(this.$axios.get(this.apiUrl + `Cache/UCMS/Companies/Company/Branch/${branchCode}`)
      .then(function(response) {
        ucmsFranchiseData = response.data;
      })
      .catch(function(error) { })
    );

      if (getTestimonials) {
        promises.push(this.$axios.get(this.apiUrl + `SocialMedia/Testimonials/Company/${franchiseId}?type=approved`)
          .then(function(response) {
            testimonials = response.data;
          })
          .catch(function(error) { })
        );
      }

      await Promise.all(promises);
    } else {
      franchiseData = await this.getOctoberData('franchises/' + slug);
      franchiseData = franchiseData[0];
      branchCode = franchiseData?.spring_green_id;
      redirectSlug = franchiseData?.redirect_url;

      if (branchCode) {
        branchData = await this.getOctoberData('branch/' + branchCode + '/branchinfo');
        branchInfo = branchData;
        franchiseId = branchInfo.SQLDBID;

        ucmsFranchiseData = (await this.$axios.get(this.apiUrl + `Cache/UCMS/Companies/Company/Branch/${branchCode}`)).data;

        if (getTestimonials) {
          testimonials = await this.getApiData(`SocialMedia/Testimonials/Company/${franchiseId}?type=approved`);
        }
      }
    }

    var info = branchInfo?.BranchInfo?.InfoData;
    const marketRegion = info?.find(function(data, _) {
      if (data.FieldName === "Marketing Metro Region") {
        return true;
      }
    });

    const phone = info?.find(function(data, _) {
      if (data.FieldName === "Business Main Phone") {
        return true;
      }
    });

    const streetAddress = info?.find(function(data, _) {
      if (data.FieldName === "Mailing Address") {
        return true;
      }
    });

    const city = info?.find(function(data, _) {
      if (data.FieldName === "Mailing City") {
        return true;
      }
    });

    const state = info?.find(function(data, _) {
      if (data.FieldName === "Mailing State") {
        return true;
      }
    });

    const zipcode = info?.find(function(data, _) {
      if (data.FieldName === "Mailing Zip Code") {
        return true;
      }
    });

    const signature = info?.find(function(data, _) {
      if (data.FieldName === "Franchise Owner Name") {
        return true;
      }
    });

    const serviceAreas = info?.find(function(data, index) {
      if (data.FieldName === "Service Areas") {
        return true;
      }
    });

    return {
      slug: slug,
      branchCode: branchCode,
      franchiseId: franchiseId,
      sqldbid: franchiseId,
      franchiseData: franchiseData,
      ucmsFranchiseData: ucmsFranchiseData,
      branchData: branchData,
      branchInfo: branchInfo,
      testimonials: testimonials,
      redirectSlug: redirectSlug,
      fields: {
        marketRegion: marketRegion,
        phone: phone,
        streetAddress: streetAddress,
        city: city,
        state: state,
        zipcode: zipcode,
        signature: signature,
        serviceAreas: serviceAreas
      }
    }
  }

  async getOrders($app, scope) {
    let orderInfo = undefined;

    // Order has been found, so query for it
    if (scope?.orderId) {
      orderInfo = await this.$app.$orders.getOrderById(
        scope.orderId,
        scope.id
      );
    }

    // Clear invalid order
    if (orderInfo?.orderType !== "NORMAL" || orderInfo?.orderStatus !== "PENDING") {
      orderInfo = undefined;
    }

    // Create new order, if no (valid) order exists and we have a scope and customer number
    if(!orderInfo && scope?.id && scope?.cust_No) {
      orderInfo = await this.$app.$orders.createOrder({custNo: scope.cust_No}, scope.id);
    }

    // Store results, if successful
    if (orderInfo?.id) {
      this.store.commit("SET_SCOPE_ORDERID", orderInfo.id);

      // TODO: (Optimization) Is this second call to get the order again from this other endpoint necessary?
      orderInfo = await this.$app.$orders.getOrderById(
        orderInfo.id,
        scope.id
      );
    }

    this.store.commit("SET_ORDER_INFORMATION", orderInfo);

    return orderInfo;
  }

  async createBillPayOrder(scope, amount, zipCode, isPrepay, prePayCode)
  {
    return await this.$app.$orders.createOrder(
      {
        OrderType: "BILLPAY", // TODO: "BILL_PAY"?
        subtotal: amount,
        total: amount,
        tax: 0,
        billingZip: zipCode,
        IsPrepay: isPrepay,
        PrepayCode: prePayCode,
      },
      scope.id,
    );
  }

  getConnectedGuides(guidesType, lawnCareGuides, pestControlGuides, treeCareGuides) {
    var guidesSlug = "lawn-care-guides";
    var guidesArray = lawnCareGuides;
    if (guidesType == "pest_control") {
      guidesSlug = "pest-control-guides";
      guidesArray = pestControlGuides;
    } else if(guidesType == "tree_care") {
      guidesSlug = "tree-care-guides";
      guidesArray = treeCareGuides;
    }
    
    if (!guidesArray || guidesArray.length == 0 || typeof guidesArray[0] == "string") {
      return undefined;
    }

    // An array of topics with an array of the guides underneath them is returned
    // so we need to combine all into one array for the carousel
    if (Array.isArray(guidesArray[0])) {
      var combinedGuides = [];

      guidesArray.forEach((topic) => {
        combinedGuides = combinedGuides.concat(topic);
      });

      guidesArray = combinedGuides;
    }

    guidesArray.forEach(function(item) {
      item.url = '/learn/' + guidesSlug + '/' + item.slug + '/';
    });

    return guidesArray;
  }

  async enterNdcCode(ndcCode, $app) {
    var ndcInfo = await this.getApiData("Offers/NDC/" + ndcCode + "/Offer")
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      return undefined;
    });

    if (!ndcInfo?.address)
    {
      return false;
    }

    var addressLine1 = ndcInfo.address.address1.trim();
    var city = ndcInfo.address.city.trim();
    var state = ndcInfo.address.state.trim();
    var zip = ndcInfo.address.zip.trim().substring(0, 5);

    const userAddress = `${addressLine1}, ${city}, ${state}, ${zip}`;

    if (ndcInfo.isExpired) {
      ndcInfo = undefined;
      ndcCode = undefined;
    }

    // NDC lookup must never also fire the Address Lookup touchpoint — pass tracking=false
    // to prevent duplicate touchpoints (and duplicate follow-up campaigns) when a user
    // submits an NDC code. The explicit NDC Lookup touchpoint is recorded separately by
    // the caller (e.g., NdcModal.codeUpdate -> $ndc.addTouchPoint).
    this.addressLookup(userAddress, $app, true, "", ndcInfo, ndcInfo?.ndc, false, true);

    return true;
  }
}
  